<template>
    <div id="page_08" class="page">
        <div class="content">
            <div class="content_area">
                <div style="font-weight:bold;">
                    Contact
                </div>
                <div class="desc">
                    사업제휴 및 창업문의는 아래 이메일을 통해 연락주시면 감사하겠습니다.
                </div>
                <div class="info">
                    <div calss="phrase">
                        <span class="sub">창업 및 입점 문의</span>
                        <span>
                            <a href="mailto:info@3rd-base.com">
                            info@3rd-base.com
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    name: "Page08"
}
</script>

<style scoped>
    .content{background-image:url("../assets/img/bg_page_08.jpg");padding-top:5.768rem;padding-bottom:9.07rem;}
    .content_area{margin:0 auto;width:16rem;}
    .desc{font-size:0.54rem;line-height:0.82rem;margin-top:0.5rem;}
    .info {font-size:0.54rem;line-height:0.82rem;margin-top:1rem;}
    .info div.phrase{padding-top:0.3rem;}
    .info span.sub{margin-right:0.6rem;}

    @media (max-width:720px) {
        .desc{font-size:0.7rem;line-height:1rem;margin-top:0.5rem;}
        .info{font-size:0.8rem;}
    }    
</style>


